import { PerformanceMonitoringService } from "./../../../profiling/service/PerformanceMonitoringService";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { BasicController } from "../BasicController";
import { JavascriptFunctionName } from "../externalInterface/JavascriptFunctionName";
import { BasicModel } from "../../model/BasicModel";
import { BasicLayoutManager } from "../../view/BasicLayoutManager";
import { CommandController } from "./../../../commanding/CommandController";
import { SimpleCommand } from "./../../../commanding/SimpleCommand";
import { ExternalInterface } from "@goodgamestudios/createjs-utilities";


export class BasicLogoutCommand extends SimpleCommand {
    public static DELETE_LOGIN_DATA_ON_LOGOUT: boolean = true;

    public execute(commandVars: any = null): void {
        // As soon as the user logs out don't treat him as first time user, stop the first instance tracking
        EnvGlobalsHandler.globals.isFirstVisitOfGGS = false;

        BasicController.getInstance().onLogOut();
        BasicModel.sessionData.resetLoggedinTimer();
        BasicModel.smartfoxClient.logout();
        BasicLayoutManager.getInstance().revertFullscreen();

        // Call javascript function "ggsOnLogout"
        ExternalInterface.call(JavascriptFunctionName.ON_LOGOUT);

        // If this was a social session: refresh the social login keys
        if (EnvGlobalsHandler.globals.isSSO) {
            // Refresh login keys
            CommandController.instance.executeCommand(BasicController.REQUEST_SOCIAL_LOGIN_KEYS);

        }
        //HTML-573 - the BasicModel.localData.deleteLoginData(); - was moved out from if statement, for fixing logout functionality
        // Delete username/password to prevent an auto login to a possibly wrong instance after the logout and a page reload.
        if ( BasicLogoutCommand.DELETE_LOGIN_DATA_ON_LOGOUT ) {
            BasicModel.localData.deleteLoginData();
        }

        PerformanceMonitoringService.getInstance().stopMonitoring();
    }
}
